import { Button, Tooltip } from '@mui/material';
import { useMemo } from 'react';
import BaseNavButtonProps from '../../lib/BaseNavButtonProps';

/**
 * The properties for the back button
 */
type BackButtonProps = {
  /**
   * A method to return to the previous module
   */
  moveToPreviousModule: () => void;
} & BaseNavButtonProps;

/**
 * The back button for course navigation
 */
const BackButton = (props: BackButtonProps) => {
  const onFirstModule = useMemo(
    () => props.selectedCourseModuleIndex == 0,
    [props.selectedCourseModuleIndex]
  );

  return (
    <Tooltip
      title={onFirstModule ? 'On First Module' : 'Previous Module'}
      arrow
    >
      <span
        style={{
          width: props.width,
          cursor: onFirstModule ? 'help' : 'pointer',
        }}
      >
        <Button
          variant="outlined"
          sx={{
            height: props.height,
            width: '100%',
          }}
          disabled={onFirstModule}
          onClick={props.moveToPreviousModule}
        >
          Back
        </Button>
      </span>
    </Tooltip>
  );
};

export default BackButton;
